import React, { useEffect, useState } from 'react';
import { CardDeck, Container, Row, Col, Form, InputGroup, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import queryString from 'query-string';
import Select from "react-dropdown-select";
import { useHistory, Link } from "react-router-dom";
import AddBoxIcon from '@mui/icons-material/AddBox';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CheckroomIcon from '@mui/icons-material/Checkroom';

//local imports
import SceneCard from './scene-card';
import TagEditor from './tag-editor';
import SpinnerLoad from '../common/spinner';
import ItemDisplay from '../common/item-display';
import PaginationComponent from '../common/pagination';
import SceneSort from '../common/scene-sort';
import { helper } from '../common/helper.js';
import FilterScene from '../common/filter-scene';
import NewScene from '../scenes/new-scene-popup';
import NewSceneTag from './new-scene-tag';
import GarmentManager from '../garment/garment-manager';
import FloatingMenu from '../common/FloatingMenu';
import ChatWidget from '../chat/ChatWidget';
import { sceneCardActions } from '../../actions/scene/sceneCardActions.js'
import NewMovie from '../scenes/new-movie-popup';
import ContentRequest from '../tv/ContentRequest';
import constants from '../../const';

import '../App.css';

function Scenes(props) {

    const { getScenes } = props;
    const [selectedCount, setSelectedCount] = useState(0)
    const [viewType, setViewType] = useState(localStorage.getItem('sceneViewType') || 'card-full')
    const [hoveredSceneId, setHoveredSceneId] = useState(null)
    const [showGarmentManager, setShowGarmentManager] = useState(false)
    const [showNewScene, setShowNewScene] = useState(false)
    const history = useHistory();
    var params = queryString.parse(props.location.search);

    if (params.page == null)
        params.page = 1;
    if (params.size == null)
        params.size = "20";
    if (params.site == null)
        params.site = -1;
    if (params.movie == null)
        params.movie = -1;
    if (params.studio == null)
        params.studio = -1;
    if (params.company == null)
        params.company = -1;
    if (params.dateReleased == null)
        params.dateReleased = "";
    if (params.sort == null)
        params.sort = "date";
    if (params.direction == null)
        params.direction = "desc";
    if (params.search == null)
        params.search = "";
    if (params.modelsort == null)
        params.modelsort = null;
    if (params.sexe == null)
        params.sexe = null;
    if (params.status == null)
        params.status = null;  
    if (params.positionCount == null)
        params.positionCount = "";  

    if (params.tag == null)
        params.tag = [];
    if (!Array.isArray(params.tag))
        params.tag = [params.tag];
    if (params.model == null)
        params.model = [];
    if (!Array.isArray(params.model))
        params.model = [params.model];


    useEffect(() => {
        props.setSceneFilter('SEARCH', params.search);
        props.getScenes(params.size, params.page, params.site, params.sort, params.direction, params.tag, params.model, params.search, params.movie, params.studio, params.company, params.dateReleased, params.modelsort, params.sexe, params.status, params.positionCount);
        // eslint-disable-next-line
    }, [getScenes]);

    const tagRefresh = (tagI) => {
        params.tag = tagI;
        props.getScenes(params.size, params.page, params.site, params.sort, params.direction, tagI, params.model, params.search, params.movie, params.studio, params.company, params.dateReleased, params.modelsort, params.sexe, params.status, params.positionCount);
    };

    const siteRefresh = (siteI) => {
        params.site = siteI;
        props.getScenes(params.size, params.page, siteI, params.sort, params.direction, params.tag, params.model, params.search, params.movie, params.studio, params.company, params.dateReleased, params.modelsort, params.sexe, params.status, params.positionCount);
    };

    const movieRefresh = (movieI) => {
        params.movie = movieI;
        props.getScenes(params.size, params.page, params.site, params.sort, params.direction, params.tag, params.model, params.search, movieI, params.studio, params.company, params.dateReleased, params.modelsort, params.sexe, params.status, params.positionCount);
    };

    const studioRefresh = (studioI) => {
        params.studio = studioI;
        props.getScenes(params.size, params.page, params.site, params.sort, params.direction, params.tag, params.model, params.search, params.movie, studioI, params.company, params.dateReleased, params.modelsort, params.sexe, params.status, params.positionCount);
    };

    const modelRefresh = (modelI) => {
        params.model = modelI;
        props.getScenes(params.size, params.page, params.site, params.sort, params.direction, params.tag, modelI, params.search, params.movie, params.studio, params.company, params.dateReleased, params.modelsort, params.sexe, params.status, params.positionCount);
    };

    const pageRefresh = (pageNumber) => {
        params.page = pageNumber;
        props.getScenes(params.size, pageNumber, params.site, params.sort, params.direction, params.tag, params.model, params.search, params.movie, params.studio, params.company, params.dateReleased, params.modelsort, params.sexe, params.status, params.positionCount);
    };

    const sizeRefresh = (size) => {
        params.size = size;
        history.push(paramURL(params.site, helper.query(params.model, "model"), helper.query(params.tag, "tag"), params.movie, params.studio, params.company, params.sort, params.direction, size));
        props.getScenes(size, 1, params.site, params.sort, params.direction, params.tag, params.model, params.search, params.movie, params.studio, params.company, params.dateReleased, params.modelsort, params.sexe, params.status, params.positionCount);
    };
    const filterRefresh = (key, item, direction) => {
        history.push(paramURL(params.site, helper.query(params.model, "model"), helper.query(params.tag, "tag"), params.movie, params.studio, params.company, item, direction, params.size));
        if (key === "sort")
            props.getScenes(params.size, params.page, params.site, item, direction, params.tag, params.model, params.search, params.movie, params.studio, params.company, params.dateReleased, params.modelsort, params.sexe, params.status, params.positionCount);
        if (key === "direction")
            props.getScenes(params.size, params.page, params.site, params.sort, direction, params.tag, params.model, params.search, params.movie, params.studio, params.company, params.dateReleased, params.modelsort, params.sexe, params.status, params.positionCount);
    };
    const sceneRefresh = (value) => {
        params.search = value;
        props.getScenes(params.size, params.page, params.site, params.sort, params.direction, params.tag, params.model, value, params.movie, params.studio, params.company, params.dateReleased, params.modelsort, params.sexe, params.status, params.positionCount);
    }


    const paramURL = (site, model, tag, movie, studio, company, sort, direction, size, ) => {
        return `/scenes?site=${site}&movie=${movie}&studio=${studio}&company=${company}${model}${tag}&size=${size}&sort=${sort}&direction=${direction == null ? params.direction : direction}&dateReleased=${params.dateReleased}&search=${params.search}&positionCount=${params.positionCount}`;
    }

    const onEdit = () =>{
        if(props.isEditing){
            props.setEditing(false)
            resetSelection()
        }
        else{
            props.setEditing(true)
        }
    }

    const selectedScenes = (id) =>{
        var arr = []
        arr = props.selectedScene
        arr.push(id)
        props.sceneSelection(arr)
        setSelectedCount(selectedCount + 1)
    }
    const unselectScene = (id) =>{
        var arr = []
        arr = props.selectedScene
        const index = arr.indexOf(id)
        if(index > -1){
            arr.splice(index, 1);
        }
        props.sceneSelection(arr)
        setSelectedCount(selectedCount-1)
    }

    const resetSelection = () =>{
        setSelectedCount(0);
        props.clearSceneSelection();
    }

    const handleViewTypeChange = (newViewType) => {
        setViewType(newViewType);
        localStorage.setItem('sceneViewType', newViewType);
    }

    var filters = [
        {
            key: "sort",
            title: "Sort By",
            items: [
                { key: "age", value: "Age When Filmed" },
                { key: "date", value: "Date" },
                { key: "length", value: "Length" },
                { key: 'size', value: 'Size' },
                { key: "title", value: "Title" },
                { key: "rating", value: "Rating (Beta)" },
                { key: "view", value: "Most Viewed" },
                { key: "res", value: "Resolution" },
                { key: "id", value: "Recently Added (ID)" },
                { key: "rand", value: "Random" },
                { key: "lastview", value: "Lastly Viewed" }
            ],
            selected: params.sort
        },
        {
            key: "direction",
            title: "Direction",
            items: [
                { key: "asc", value: "ASC" },
                { key: "desc", value: "DESC" }],
            selected: params.direction
        },
        {
            key: "size",
            title: "# Item",
            items: [
                { key: "20", value: "20" },
                { key: "32", value: "32" },
                { key: "50", value: "50" },
                { key: "100", value: "100" }],
            selected: params.size
        }
    ]
    if (filters[2].items.find(a => a.key === filters[2]?.selected) == undefined) {
        filters[2].items.push({ key: params.size, value: params.size });
    }

    if (!props.isFetching.scene) {
        var scenes = props.sceneCard;
        var sceneCardElement = [];
        var i = 0;

        if (viewType === 'list') {
            // List View
            sceneCardElement = (
                <div style={{ width: '100%' }}>
                    {scenes.map((scene, idx) => {
                        var token = `?token=${localStorage.getItem('token').slice(7)}`;
                        var fileRole = props?.perms?.some(e => e.role.id === 12);
                        var videoUrl = `${process.env.REACT_APP_CONTENT_DOMAIN || 'http://localhost:3001'}${scene.scene.videoFull}${token}`;
                        return (
                            <Row key={idx} className="g-0" style={{ 
                                borderBottom: '1px solid #eee', 
                                padding: '10px',
                                alignItems: 'center',
                                fontSize: '12px'
                            }}>
                                <Col style={{ display: 'flex', alignItems: 'center', flexShrink: 0, paddingRight: '10px' }}>
                                    {console.log(`${constants.TRAILER_CDN}${scene.scene.posterURL}`)}
                                    <div
                                        onMouseEnter={() => setHoveredSceneId(scene.scene.sceneId)}
                                        onMouseLeave={() => setHoveredSceneId(null)}
                                        style={{
                                            width: '210px',
                                            height: '120px',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            overflow: 'hidden',
                                            position: 'relative'
                                        }}
                                        onClick={() => props.history?.push(`/scene/${scene.scene.sceneId}`)}
                                    >
                                        {hoveredSceneId === scene.scene.sceneId ? (
                                            <video
                                                width="210"
                                                height="120"
                                                autoPlay
                                                muted
                                                loop
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover'
                                                }}
                                                onClick={() => props.history?.push(`/scene/${scene.scene.sceneId}`)}
                                            >
                                                <source src={`${constants.TRAILER_CDN}${scene.scene.videoURL}`} type="video/mp4" />
                                            </video>
                                        ) : (
                                            <img 
                                                src={`${constants.TRAILER_CDN}${scene.scene.posterURL}`}
                                                alt={scene.scene.title}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    aspectRatio: '350/200'
                                                }}
                                            />
                                        )}
                                    </div>
                                </Col>
                                <Col md={3} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    <Link to={`/scene/${scene.scene.sceneId}`} style={{ color: '#667eea', textDecoration: 'none', fontWeight: 'bold' }}>
                                        {scene.scene.title}
                                    </Link>
                                </Col>
                                <Col md={2}>
                                    {scene.site ? scene.site.name : '—'}
                                </Col>
                                <Col md={2}>
                                    {scene.actors?.map(a => a.name).join(', ') || '—'}
                                </Col>
                                <Col md={1}>
                                    {scene.duration} min
                                </Col>
                                <Col md={1}>
                                    {scene.scene.date?.slice(0, 10) || '—'}
                                </Col>
                                <Col md={2} className="d-flex gap-2" style={{ gap: '8px' }}>
                                    {fileRole ? (
                                        <a href={videoUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#667eea', textDecoration: 'none', fontSize: '12px' }}>
                                            Video
                                        </a>
                                    ) : null}
                                    <Link to={`/scene/${scene.scene.sceneId}`} style={{ color: '#764ba2', textDecoration: 'none', fontSize: '12px' }}>
                                        Details
                                    </Link>
                                </Col>
                            </Row>
                        );
                    })}
                </div>
            );
        } else {
            // Card View (Full or Minimal)
            var colSize = viewType === 'card-minimal' ? 3 : 1;
            for (var col = 0; col < Math.ceil(scenes.length / colSize); col++) {
                var cardDeck = [];
                for (var row = 0; row < colSize; row++) {
                    if (i < scenes.length) {
                        cardDeck.push(<SceneCard 
                            key={row} 
                            style={{ width: viewType === 'card-minimal' ? "220px" : "350px" }} 
                            scene={scenes[i]} 
                            siteRefresh={siteRefresh} 
                            movieRefresh={movieRefresh} 
                            filterTrue={true} 
                            roles={props.perms} 
                            selectScene={selectedScenes} 
                            unselectScene={unselectScene} 
                            editor={props.isEditing}
                            viewType={viewType}
                            settings={{
                                "menu": {
                                  addToFavorite: true,
                                  addToPlaylist: true
                                }
                            }}
                        />);
                        i++;
                    }
                }
                sceneCardElement.push(<CardDeck key={col} style={{ padding: "2px" }}>{cardDeck}</CardDeck>);
            }
        }
    }
    return (
        <>
            <ContentRequest />
            <Container fluid >
                <Row>
                    {props.isEditing?<Col xs={1}><TagEditor/></Col>:null}
                    <Col>
                        <Container style={{ maxWidth: `${window.innerWidth}px` }}>
                            <Container>
                                <FilterScene filters={filters} params={params}
                                    baseUrl={`/scenes${helper.tagQuery(params.tag, "tag")}${helper.query(params.model, "model")}&movie=${params.movie}&studio=${params.studio}&company=${params.company}&site=${params.site}&size=${params.size}&dateReleased=${params.dateReleased}&search=${params.search}&positionCount=${params.positionCount}`}
                                    site={siteRefresh} movie={movieRefresh} studioRefresh={studioRefresh} model={modelRefresh} tag={tagRefresh} filterRefresh={filterRefresh} sceneRefresh={sceneRefresh}></FilterScene>
                                <Row className='pb-3'>
                                    <Col md={5}>
                                        <Row>
                                            <Col className="pt-3">{!props.isFetching.count ? <>
                                            <h1 style={{ fontSize: "30px" }}>{`${props.count} Scenes`}</h1>
                                            {props.isEditing?<h3 style={{ fontSize: "15px" }} >{`\n${selectedCount} Selected`}</h3>:null}
                                            </> : <SpinnerLoad />} </Col>
                                        </Row>
                                    </Col>
                                    <Col md={7}>
                                        <Row className='justify-content-end'>
                                            <Col className="pt-3 p-1" md="auto">
                                                <SceneSort 
                                                    filters={filters}
                                                    params={params}
                                                    filterRefresh={filterRefresh}
                                                    sizeRefresh={sizeRefresh}
                                                    viewType={viewType}
                                                    setViewType={handleViewTypeChange}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="justify-content-center">
                                    <PaginationComponent
                                        baseUrl={`/scenes${helper.tagQuery(params.tag, "tag")}${helper.query(params.model, "model")}&sort=${params.sort}&direction=${params.direction}&movie=${params.movie}&studio=${params.studio}&company=${params.company}&site=${params.site}&size=${params.size}&search=${params.search}&dateReleased=${params.dateReleased}&positionCount=${params.positionCount}&page=`}
                                        params={params} totalItem={props.count} paginate={pageRefresh} />
                                </Row>
                                <Row>{props.isFetching.scene ? <SpinnerLoad /> : null}</Row>
                            </Container>
                            <Container style={{ maxWidth: `${window.innerWidth}px` }}>
                                <Row className="justify-content-center" >{sceneCardElement}</Row>
                                <Row className="justify-content-center">
                                    <PaginationComponent
                                        baseUrl={`/scenes${helper.tagQuery(params.tag, "tag")}${helper.query(params.model, "model")}&sort=${params.sort}&direction=${params.direction}&movie=${params.movie}&studio=${params.studio}&company=${params.company}&site=${params.site}&size=${params.size}&dateReleased=${params.dateReleased}&search=${params.search}&positionCount=${params.positionCount}&page=`}
                                        params={params} totalItem={props.count} paginate={pageRefresh} />
                                </Row>
                            </Container>
                        </Container> 
                    </Col>
                </Row>
            </Container>

            {/* Floating Menu for Admins - positioned above ChatWidget */}
            {props.perms.some(e => e.role.id === 1) && (
              <FloatingMenu 
                bottom="100px"
                right="20px"
                zIndex={999}
                items={[
                  {
                    label: 'New Scene',
                    icon: <AddBoxIcon />,
                    action: () => setShowNewScene(true)
                  },
                  {
                    label: 'Tags',
                    icon: <LocalOfferIcon />,
                    action: onEdit
                  },
                  {
                    label: 'Garment Manager',
                    icon: <CheckroomIcon />,
                    action: () => setShowGarmentManager(!showGarmentManager)
                  }
                ]}
              />
            )}

            {/* Chat Widget Below Floating Menu */}
            <ChatWidget />

            {/* Render NewScene component with show prop */}
            <NewScene show={showNewScene} onClose={() => setShowNewScene(false)} />

            {/* Render GarmentManager Directly */}
            <GarmentManager show={showGarmentManager} onClose={() => setShowGarmentManager(false)} />
        </>)
}

const mapStateToProps = (state) => {
    return {
        perms: state.users.permissions.perms,
        isFetching: state.sceneCardReducers.fetching,
        sceneCard: state.sceneCardReducers.scenes,
        count: state.sceneCardReducers.count,
        filters: state.sceneCardReducers.sceneFilters,
        params: state.scenesParamsReducers,
        fetching: state.sceneCardReducers.fetching,
        isEditing: state.sceneCardReducers.isEditing,
        selectedScene: state.sceneCardReducers.selectedScene
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getScenes: (size, page, site, sort, direction, tag, model, search, movie, studio, company, dateReleased, modelsort, sexe, status, positionCount) => dispatch(sceneCardActions.getSceneCard(size, page, site, sort, direction, tag, model, search, movie, studio, company, dateReleased, modelsort, sexe, status, positionCount)),
        setSceneFilter: (param, val) => dispatch(sceneCardActions.setSceneFilter(param, val)),
        setEditing: (edit) => dispatch(sceneCardActions.setSceneEditRequest(edit)),
        sceneSelection:(scenes) => dispatch(sceneCardActions.sceneSelection(scenes)),
        clearSceneSelection:() => dispatch(sceneCardActions.clearAllSceneSelection())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Scenes);